window.addEventListener("load", () => {
  const webformBlock = document.querySelector(".popup-block");

  if (webformBlock) {
    if (!webformBlock.querySelector(".popup-close")) {
      webformBlock
        .querySelector(".content form")
        .insertAdjacentHTML(
          "beforeend",
          "<div class='popup-close'></div>"
        );
    }

    webformBlock.addEventListener("click", function (event) {
      if (!event.target.closest(".content")) {
        webformBlock.classList.remove("opened");
        document.body.classList.remove("webform-popup-opened");
        document.body.classList.remove("category-popup-opened");
        document.documentElement.classList.remove("category-popup-opened");
      }
    });

    const popupClose = webformBlock.querySelector(".popup-close");

    if (popupClose) {
      popupClose.addEventListener("click", function () {
        webformBlock.classList.remove("opened");
        document.body.classList.remove("webform-popup-opened");
        document.body.classList.remove("category-popup-opened");
        document.documentElement.classList.remove("category-popup-opened");
      });
    }
  }
});